
      import '@folkjs/labs/standalone/folk-shape';
      import '@folkjs/labs/standalone/folk-event-propagator';

      // Mock API functions
      window.fetchRandomColor = async () => {
        const timestamp = new Date().toLocaleTimeString();
        document.getElementById('apiResponse').textContent += `\n[${timestamp}] Started color fetch`;

        // Simulate a network delay
        await new Promise((resolve) => setTimeout(resolve, 1000));

        const colors = ['#1E88E5', '#D81B60', '#8E24AA', '#43A047', '#FFB300', '#F4511E'];
        const randomColor = colors[Math.floor(Math.random() * colors.length)];

        document.getElementById('apiResponse').textContent += `\n[${timestamp}] Finished color fetch: ${randomColor}`;
        return randomColor;
      };

      window.fetchRandomData = async () => {
        const timestamp = new Date().toLocaleTimeString();
        document.getElementById('apiResponse').textContent += `\n[${timestamp}] Started data fetch`;

        // Simulate a network delay
        await new Promise((resolve) => setTimeout(resolve, 2000));

        const words = ['Amazing', 'Wonderful', 'Fantastic', 'Spectacular', 'Incredible'];
        const randomWord = words[Math.floor(Math.random() * words.length)];

        document.getElementById('apiResponse').textContent += `\n[${timestamp}] Finished data fetch: ${randomWord}`;
        return randomWord;
      };
    